import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, map, combineLatest } from '@node_modules/rxjs';
import { TranslateService } from '@node_modules/@ngx-translate/core';

/** Channel icons shipped as full-color brand logos instead of a white-glyph mask. */
const FULL_COLOR_CHANNEL_ICONS = ['rcs', 'ms-teams'];

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input()
  public url?: string;
  @Input()
  public size = '30';

  @Input()
  public overlappingSvgIcon = '';
  @Input()
  public overlappingClass = '';

  public overlappingTypeValue$ = new BehaviorSubject<string>('');

  public isWidgetOrInternal$ = this.overlappingTypeValue$
    .asObservable()
    .pipe(map((type) => type === 'widget' || type === 'internal'));

  public iconClasses$ = combineLatest([this.isWidgetOrInternal$, this.overlappingTypeValue$]).pipe(
    map((isWidgetOrInternal, overlappingType) => {
      // Full-color brand logos keep their native fill: the white-glyph-on-background
      // treatment the other channels use would paint every <path> white, leaving only
      // the parts drawn as <circle> visible over a light background.
      if (FULL_COLOR_CHANNEL_ICONS.includes(this.overlappingSvgIcon)) {
        return [this.overlappingClass];
      }
      if (!isWidgetOrInternal) {
        return [this.overlappingClass];
      }
      return ['white', 'avatar__overlapping__padding', 'avatar__overlapping__bg__' + overlappingType];
    })
  );

  @Input()
  set overlappingType(value: string | undefined) {
    const newValue = value ?? '';
    this.overlappingTypeValue$.next(newValue ? this.translate.instant(newValue) : '');
  }
  @Input()
  public centralize?: boolean = true;
  @Input()
  public setIconSize?: boolean = false;

  constructor(private translate: TranslateService) {}
}
